/**
 * Derive display age from DICOM DA (YYYYMMDD) patient birth date.
 */
export function computeAgeFromDicomDate(birthDate: string | null | undefined): number | undefined {
  if (!birthDate || birthDate.length < 8) {
    return undefined;
  }
  const y = parseInt(birthDate.slice(0, 4), 10);
  const m = parseInt(birthDate.slice(4, 6), 10) - 1;
  const d = parseInt(birthDate.slice(6, 8), 10);
  if (Number.isNaN(y) || Number.isNaN(m) || Number.isNaN(d)) {
    return undefined;
  }
  const birth = new Date(y, m, d);
  if (Number.isNaN(birth.getTime())) {
    return undefined;
  }
  const today = new Date();
  let age = today.getFullYear() - birth.getFullYear();
  const monthDiff = today.getMonth() - birth.getMonth();
  if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birth.getDate())) {
    age -= 1;
  }
  return age;
}
